<template>
  <el-container style="height: 100%">
    <el-header>
      <el-row>
        <el-col style="width: 50px;margin: 10px 0px">
          <el-image :src="detail.basic.avatar || ''"
                    style="width: 40px; height: 40px;" />
        </el-col>
        <el-col :span="20"
                style="text-align: left;">
          <span style="line-height: 60px;">{{detail.basic.nickname}}</span>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-container style="height: 100%;">
        <el-aside style="width: 35%; border-right: solid 1px #e6e6e6; padding-right: 10px; text-align: left;height: 100%">
          <el-container>
            <el-header style="height: auto; padding: 0;line-height: 25px;background-color:transparent">
              <row-table :row_list="basic_info_table"></row-table>
              <el-button size="mini"
                         @click="loadAIHistory"
                         icon="el-icon-refresh">刷新AI历史</el-button>
              <hr class="content-hr">
            </el-header>
            <el-main style="text-align: left;"
                     class="chat-box">
              <div v-for="(v, k) in aiHistory"
                   :key="k"
                   :style='"margin:2px 0px;padding: 3px 10px; background-color:" + (v.from.type == 2 ? "#d3e0f1" : "#d3e8e8")'>
                <span style='font-weight: bold'>{{v.from.type == 2 ? '代理人' : '理先生'}}</span>
                <span style="font-size: 12px;white-space: pre-line;">({{getDisplayTime(v.time)}})：</span>
                <span v-if='v.subject=="text"'>{{v.body.message}}</span>
                <span v-if='v.subject=="answer"'>{{"[答题]" + v.body.id + ": " + v.body.answer}}</span>
                <span v-if='v.subject=="choice"'>{{"[选择]" + JSON.stringify(v.body)}}</span>
                <span v-if='v.subject=="script"'>
                  [剧场脚本]
                  <span v-for='(x,y) in v.body.actions'
                        :key='y'>
                    <span v-if='x.persistent'><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{x.type + (x.data.desc ? ": " + x.data.desc : "")}}</span></span>
                  </span>
                </span>
                <br>
              </div>
            </el-main>
          </el-container>
        </el-aside>
        <el-main>
          <el-table :data="detail.client_list || []" @row-click="handleGoCustom">
            <el-table-column prop="user_id"
                             label="ID"></el-table-column>
            <el-table-column prop="name"
                             label="姓名"></el-table-column>
            <el-table-column prop="mobile"
                             label="手机号"></el-table-column>
            <el-table-column prop="gender"
                             label="性别"
                             :formatter="(_, _1, v) => { return v === 0 ? '女' : '男' }"></el-table-column>
            <el-table-column prop="time"
                             label="时间"></el-table-column>
          </el-table>
        </el-main>
      </el-container>

    </el-main>
  </el-container>
</template>
<style>
.content-hr {
  border-color: #f2f6fc;
}
</style>
<script>
import request from '../../api/request'
import RowTable from '../ui/RowTable'

export default {
  name: "AgentDetail",
  components: {
    RowTable
  },
  data() {
    return {
      agentId: 0,
      detail: {
        basic: {},
      },
      aiHistory: []
    }
  },
  computed: {
    basic_info_table() {
      if (Object.keys(this.detail).length === 0) {
        return []
      }

      return [
        [
          { span: 5, key: "ID", val: this.detail.basic.id },
          { span: 6, key: "邀请人", val: this.detail.basic.invite_id },
          { span: 13, key: "渠道", val: this.detail.basic.cid },
        ],
        [
          { span: 24, key: "注册时间", val: this.detail.basic.time },
        ],
        [
          { span: 24, key: "最后登录IP", val: this.detail.basic.last_ip },
        ],
        [
          { span: 24, key: "所属组", val: this.detail.group_id },
        ]
      ]
    }
  },
  created() {
    this.agentId = parseInt(this.$router.currentRoute.params['aid']) || 0
    request.agent.post("agent_get_detail", { id: this.agentId }).then(r => {
      this.detail = r.data
      this.loadAIHistory()
    })
  },
  methods: {
    getDisplayTime(tm) {
      let t1 = new Date(tm).getTime()
      let t2 = new Date().getTime()
      if (t2 - t1 > 86400000) {
        return tm.split(' ')[0]
      }
      return tm.split(' ')[1]
    },
    loadAIHistory() {
      request.agent.post("agent_get_ai_history", { id: this.agentId }).then(r => {
        this.aiHistory = r.data.list

        let that = this
        setTimeout(function () {
          var container = that.$el.querySelector('.chat-box')
          container.scrollTop = container.scrollHeight + 50
        }, 50)
      })
    },
    handleGoCustom(row) {
      this.$router.push(`/agent/custom/${row.user_id}/${row.person_id}`)
    }
  }

}
</script>
